export enum BuildingsActionTypes {
  REQUEST_BUILDINGS_START = '@@buildings/REQUEST_BUILDINGS_START',
  REQUEST_BUILDINGS_SUCCESS = '@@buildings/REQUEST_BUILDINGS_SUCCESS',
  REQUEST_BUILDINGS_FAILED = '@@buildings/REQUEST_BUILDINGS_FAILED',
}
